module.exports = __webpack_public_path__ + "images/paywall-body-icon-explicit.8318ff78dc8400641f034e28bd13f365.png";